import React from 'react';
import { NavLink } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const Sidebar = ({ visible, onClose }) => {
  const { hasRole } = useUser();

  const handleLinkClick = () => {
    // Close sidebar on mobile when a link is clicked
    if (window.innerWidth < 768 && onClose) {
      onClose();
    }
  };

  return (
    <aside className={`app-sidebar ${!visible ? 'collapsed' : ''}`}>
      <nav className="nav flex-column p-3" style={{ gap: '0.5rem' }}>
        {/* Dashboard link based on role */}
        {hasRole('super_admin') ? (
          <NavLink to="/super-admin/dashboard" className="nav-link text-white" onClick={handleLinkClick}>
            <i className="bi bi-speedometer2 me-2"></i>
            Dashboard
          </NavLink>
        ) : hasRole('admin') ? (
          <NavLink to="/admin/dashboard" className="nav-link text-white" onClick={handleLinkClick}>
            <i className="bi bi-speedometer2 me-2"></i>
            Dashboard
          </NavLink>
        ) : (
          <NavLink to="/dashboard" className="nav-link text-white" onClick={handleLinkClick}>
            <i className="bi bi-speedometer2 me-2"></i>
            Dashboard
          </NavLink>
        )}

        {/* Admin menu items - ONLY for regular admins, NOT super_admin */}
        {hasRole('admin') && !hasRole('super_admin') && (
          <>
            <NavLink to="/admin/elections" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-calendar-event me-2"></i>
              Elections
            </NavLink>

            <NavLink to="/admin/members" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-people me-2"></i>
              Voters
            </NavLink>

            <NavLink to="/admin/groups" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-collection me-2"></i>
              Groups
            </NavLink>

            <NavLink to="/admin/results" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-bar-chart me-2"></i>
              Results
            </NavLink>

            <NavLink to="/admin/transactions" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-cash-stack me-2"></i>
              Transactions
            </NavLink>
            <NavLink to="/admin/billing" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-credit-card me-2"></i>
              Billing
            </NavLink>

            <NavLink to="/admin/payouts" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-wallet2 me-2"></i>
              Payouts
            </NavLink>

            <NavLink to="/admin/reports" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-download me-2"></i>
              Exports
            </NavLink>

            <NavLink to="/admin/settings" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-gear me-2"></i>
              Settings
            </NavLink>
          </>
        )}

        {/* Voter menu items - ONLY for voters */}
        {hasRole('voter') && !hasRole('admin') && !hasRole('super_admin') && (
          <>
            <NavLink to="/voter/organizations" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-building me-2"></i>
              Organizations
            </NavLink>
          </>
        )}

        {/* Wallet link - for voters and candidates */}
        {(hasRole('voter') || hasRole('candidate')) && !hasRole('admin') && !hasRole('super_admin') && (
          <NavLink to="/wallet" className="nav-link text-white" onClick={handleLinkClick}>
            <i className="bi bi-wallet2 me-2"></i>
            My Wallet
          </NavLink>
        )}

        {/* Super Admin menu items */}
        {hasRole('super_admin') && (
          <>
            <hr className="border-secondary" />
            <div className="text-white-50 small mb-2 mt-3" style={{ fontSize: '0.75rem', fontWeight: '600', letterSpacing: '0.5px' }}>SUPER ADMIN</div>

            <NavLink to="/super-admin/users" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-people me-2"></i>
              Users
            </NavLink>

            <NavLink to="/super-admin/organizations" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-building me-2"></i>
              Organizations
            </NavLink>

            <NavLink to="/super-admin/pricing-packages" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-tags me-2"></i>
              Pricing Packages
            </NavLink>

            <NavLink to="/super-admin/subscriptions" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-calendar-check me-2"></i>
              Subscriptions
            </NavLink>

            <NavLink to="/super-admin/transactions" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-cash-stack me-2"></i>
              Transactions
            </NavLink>

            <NavLink to="/super-admin/payouts" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-wallet2 me-2"></i>
              Payouts
            </NavLink>

            <NavLink to="/super-admin/audit-logs" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-file-text me-2"></i>
              Audit Logs
            </NavLink>

            <NavLink to="/super-admin/settings" className="nav-link text-white" onClick={handleLinkClick}>
              <i className="bi bi-gear me-2"></i>
              Settings
            </NavLink>
          </>
        )}

      </nav>
    </aside>
  );
};

export default Sidebar;
